import { render, staticRenderFns } from "./PpeRegisterSubmission.vue?vue&type=template&id=9e390ed8&"
import script from "./PpeRegisterSubmission.vue?vue&type=script&lang=js&"
export * from "./PpeRegisterSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports